<template>
  <div class="register">
    <img class="xl-logo" src="../../../static/img/logo@3x.png" alt />
    <img class="xl-bg" src="../../../static/img/loginbg@3x.png" alt="" />
    <div class="phone-window">
      <div class="phone-cont">
        <input
          type="text"
          :class="{ active: is_phone }"
          @focus="handleFocus(1)"
          @blur="handleBlur(1)"
          placeholder="请输入手机号"
          v-model="phone"
        />
        <img class="clear-img" v-if="phone" @click="handleClear" src="../../../static/img/del@3x.png" alt="">
      </div>
      <div class="phone-cont" style="margin-bottom: 0">
        <input
          type="text"
          :class="{ active: is_code }"
          @focus="handleFocus(2)"
          @blur="handleBlur(2)"
          class="auth-code"
          placeholder="请输入验证码"
          v-model="code"
          maxlength="4"
        />
        <button class="yanzheng-btn" @click="getCode" v-if="!disabled">
          获取验证码
        </button>
        <button class="yanzheng-btn disabled-btn" v-else>
          重新获取 {{ time }}s
        </button>
      </div>
    </div>
    <div v-show="hideshow" class="phone-btm f_c_c" @click="submitCode">登录</div>
    <div class="tips">
      登录即同意<span @click="handlePdf(1)" style="color: #1890FF;"
        >《用户注册协议》(包含互联网诊疗风险告知及知情同意书)</span
      >及
      <span @click="handlePdf(2)" style="color: #1890FF;"
        >《法律声明与隐私政策》</span
      >
    </div>
  </div>
</template>

<script>
import http from "../../request/http";
import {mapState} from 'vuex'
export default {
  name: "bind_phone",
  data() {
    return {
      phone: "",
      code: "",
      time: 60,
      disabled: false,
      nickname: "",
      timerOut: null,
      docmHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      showHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      hideshow: true,
      is_phone: false,
      is_code: false,
    };
  },
  watch: {
    //监听显示高度
    // showHeight: function () {
    //   if (this.docmHeight > this.showHeight) {
    //     //隐藏
    //     this.hideshow = false;
    //   } else {
    //     //显示
    //     this.hideshow = true;
    //   }
    // },
  },
  methods: {
    handleFocus(index) {
      if (index == 1) {
        this.is_phone = true;
      } else {
        this.is_code = true;
      }
    },
    handleBlur(index) {
      if (index == 1) {
        this.is_phone = false;
      } else {
        this.is_code = false;
      }
    },
    handlePdf(type) {
      let pdf = "";
      if (type == 1) {
        pdf = "user_register_protocol.pdf";
      } else if (type == 2) {
        pdf = "legal_notice.pdf";
      }
      this.$router.push({
        name: "pdf_template",
        query: {
          pdf: pdf,
        },
      });
    },
    handleClear(){
      this.phone = ''
    },
    submitCode() {
      http
        .post("/api/wap/user/buldmobile", {
          mobile: this.phone,
          code: this.code,
        })
        .then((res) => {
          console.log(res);
          if (res.errno == 0) {
            this.$toast.center("绑定成功");
            setTimeout(() => {
              if(this.router_back){
                this.$router.push({path:this.router_back.path,query:this.router_back.query,parms:this.router_back.params});
              }else{
                this.$router.push('/')
              }
            }, 500);
          } else {
            this.$toast.center(res.errmsg);
          }
        });
    },
    goBack(){
      this.$router.replace({path: '/'});
      //replace替换原路由，作用是避免回退死循环
    },
    getCode() {
      if(!this.phone){
        this.$toast.center('手机号不能为空');
        return;
      }
      http
        .post("/api/wap/user/sendcode", {
          mobile: this.phone,
        })
        .then((res) => {
          if (res.errno == 0) {
            this.disabled = true;
            let timer = null;
            this.$toast.center("验证码发送成功");
            let count = 0;
            this.timeOut();
          } else {
            this.$toast.center(res.errmsg);
          }
        });
    },
    timeOut() {
      if(this.timerOut){
        clearTimeout(this.timerOut);
        this.timerOut = null;
      }
      this.timerOut = setTimeout(() => {
        if (this.time == 0) {
          clearTimeout(this.timerOut);
          this.timerOut = null;
          this.disabled = false;
          this.time = 60;
          return false;
        }
        this.time--;
        this.timeOut();
      }, 1000);
    },
  },
  created() {

},
  computed:{
    ...mapState(['router_back'])
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      //window.addEventListener('popstate', this.goBack, false);
      // 注释掉监听，避免绑定手机号回首页。
    }
    window.onresize = () => {
      return (() => {
        this.showHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
      })();
    };
  },
  destoryed() {
      //window.removeEventListener('popstate', this.goBack, false);
    if (this.timerOut) {
      clearTimeout(this.timerOut);
      this.timerOut = null;
      this.time = 60;
    }
  },
};
</script>

<style scoped>
.register {
  width: 100vw;
  height: 100vh;
  background: #fff;
  padding-top: 2.1rem;
  box-sizing: border-box;
  position: relative;
}
.register .xl-logo {
  width: 8.6rem;
  margin-left: calc(50vw - 4.3rem);
}
.xl-bg {
  width: 4.675rem;
  position: absolute;
  top: 0.5rem;
  right: 0;
}
.phone-window {
  width: calc(100vw - 2rem);
  margin: 3.4rem auto 0;
}
.phone-cont {
  width: 100%;
  height: 2.65rem;
  position: relative;
  margin-bottom: 0.9rem;
}
.phone-cont-left {
  width: 2.6rem;
  height: 2.2rem;
  line-height: 2.2rem;
  font-size: 0.8rem;
  margin-right: 0.75rem;
  float: left;
}

.phone-cont input {
  width: 100%;
  height: 2.65rem;
  border: none;
  border-bottom: 0.05rem solid #f5f5f5;
  padding: 0.7rem 0.5rem 0.75rem;
  outline: none;
  box-sizing: border-box;
  line-height: 1.2rem;
  color: rgba(38, 38, 38, 100);
  font-size: 0.8rem;
}
input.active {
  border-color: #98ceff;
}
.phone-cont .auth-code {
  width: 100%;
  padding-right: 3.6rem;
}
.yanzheng-btn {
  width: 5rem;
  text-align: right !important;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  border-radius: 0.25rem;
  background-color: #fff;
  border: none;
  color: rgba(24, 144, 255, 1);
  box-sizing: border-box;
  font-size: 0.7rem;
  position: absolute;
  top: 0.8rem;
  right: 0.25rem;
}
.yanzheng-btn:disabled {
  border-color: #8cc5ff;
  color: #8cc5ff;
}
.phone-btm {
  height: 2.2rem;
  width: calc(100vw - 2.75rem);
  border-radius: 1.1rem;
  background-color: rgba(24, 144, 255, 1);
  font-size: 0.75rem;
  color: #fff;
  margin: 2.6rem 1.375rem 1.45rem;
  background-image: linear-gradient(180deg, #43a5ff 0%, #4890ff 100%);
  box-shadow: 0 0.2rem 0.2rem 0 rgba(24, 124, 255, 0.23);
}
.checks {
  height: 3.9rem;
  padding-bottom: 1.4rem;
}
.checks p {
  font-size: 0.7rem;
  line-height: 1rem;
}
.checks a {
  color: rgba(24, 144, 255, 1);
}
.icon-checked {
  content: url("../../../static/icons/selected@3x.png");
}
.disabled-btn {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.25);
}
.checks-right {
  width: calc(100vw - 2.1rem);
  color: rgba(109, 114, 120, 1);
}
input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
}
input:-moz-placeholder {
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
}
input::-moz-placeholder {
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
}
input:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
}
.f_c_c {
  display: flex;
  justify-content: center;
  align-items: center;
}
.tips{
  width: calc(100vw - 3.6rem);
  margin:0 1.7rem 0 1.9rem;
  text-align: left;
  line-height: 1rem;
  color:#333;
  font-size: 0.55rem;
}
.clear-img{
  width: 0.9rem;
  height: 0.9rem;
  position: absolute;
  bottom: 0.95rem;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/bind_phone/bind_phone.vue